

import React, { memo } from 'react';
import HeatmapContainer from '../containers/Heatmap';
import HeatmapMonthCell from './HeatmapMonthCell';
import { getMonthNames } from '../utils/getMonthNames';




function HeatmapWithMonths({ monthsCount }) {
  const months = getMonthNames(monthsCount);

  return (
    <HeatmapContainer>
      {months.map((month) =>
      <HeatmapMonthCell
        key={month}
        month={month} />

      )}
    </HeatmapContainer>);

}

export default memo(HeatmapWithMonths);